const translations_en = {
    translation:{
        headlines:{
            resistanceInformation: 'Chemical Resistance Information',
            resultHeadline: 'The following information is available for {{media}}'
        },
        labels: {
            searchResults: 'Search results for:',
            materialCategory: 'Material category',
            filterEignung: 'Only show columns with the following values',
            selectedFilter: 'Active filter:',
            material: 'Material',
            medium: 'Medium',            
            selectStandardViewSubText: 'Quickly find the appropriate resistance using media/materials',
            selectExpertViewSubText: 'All media material combinations in a table containing an overview',
            temperaturSelected:'max. media temperature:',
            temperaturSelection:'Please select maximum media temperature for {{medium}}:',
            konzentrationSelected:'max. concentration:',
            konzentrationSelection:'Please select maximum concentration for {{medium}}:',
            zustandSelected:'Medium status:',
            zustandSelection:'Please select the medium status:',
            mediumSelected:'Medium:',
            mediumSelection:'Please select a unique medium:',
            completeMediumSelection: 'Please select the other information for the medium above',
            mediumMissing: 'Please select a working medium',
            contact:{
                button: 'Contact',
                title: 'We\'re happy to help.',
                text : 'Got any questions about our resistance information?'
            },
            lastModified: 'Database'  
        },
        buttons:{
            search: 'search',
            accept: 'Accept',
            exportExcel: 'Save data as excel file',
            language: 'Language',
            refreshData: 'Refresh data'
        },
        infoText:{
            hiddenColumns: 'There is no information available for the following materials:',
            hintLimitations: 'Please contact us for further information about the materials in this category.'
        },
        placeholder:{
            search: "Medium/material/formula/CAS no.",
            materialCategory: 'Select category',
            filterEignung: 'Select values'
        },
        info:{
            loading:{
                init: 'Data is being loaded...',
                progress: "Getting more information..."

            }
        },
        table:{
            itemsPerPage:'Items per Page: ',
            head:{
                Medium: 'Medium',
                Alternative_Namen: 'Alternate names',
                Formel: 'Formela',
                CAS_Nr: 'CAS-No.',
                Konzentration:'Concentration',
                Temperatur: 'Temperature',
                Zustand:'State',
                Anmerkung: 'Note'
            },
            gridLabels:{
                noRowsToShow: 'No information available',
                page: 'Page',
                more: 'more',
                to: 'to',
                of: 'of',
                next: 'next',
                last: 'last',
                first: 'first',
                previous: 'previous',
                loadingOoo: 'loading...',
                contains: 'contains',
                notContains: 'not contains',
                equals: 'equals',
                notEquals: 'not equals',
                startsWith: 'starts with',
                endsWith: 'ends with',
                filterOoo:'filter...',
                andCondition: 'and',
                orCondition: 'or'
            },
            select: {
                noResults: '(No results)'
            }
        },
        key:{
            title:'Key',
            suitable: 'suitable',
            suitableAnm: 'suitable (with restrictions)',
            lsuitability: 'limited suitability',
            lsuitabilityAnm: 'limited suitability (with restrictions)',
            nsuitability: 'not suitable',
            noInfo: 'not specified',
            Eignung: 'Suitability',
            TR: 'technically pure, almost 100%',
            completeKey: 'complete key',
            DeRatingFactorTitle: 'De-rating factor',
            DeRatingFactorText:'Valves and pipelines are designed according to DIN EN ISO 16138 for a service life of 25 years. Due to the influence of chemicals sometimes a reduction factor for pressure or temperature is given. In connection with the pressure-temperature diagram, the maximum permitted pressure or temperature for the corresponding chemical can be calculated.'
        },
        resistanceKeys:{
            '+': 'Resistant materials',
            '(+)': 'Resistant materials - with limitations', 
            'o': 'Conditionally resistant materials',
            '(o)': 'Conditionally resistant materials - with limitations',
            '-': 'Non-resistant materials',
            '(-)': 'Non-resistant materials - with limitations',
            'kA': 'No information available',
            'title':'Explanations on durability'
        },
        resistanceDescriptions:{
            '+':'(low or no impairment)',
            'o': '(weak to moderate attack)',
            '-':'(severe attack to complete destruction)'
        },
        resistanceTranslations:{
            title:{
                '+': 'Resistant',
                '(+)': 'Resistant - with limitations', 
                'o': 'Conditionally resistant',
                '(o)': 'Conditionally resistant - with limitations',
                '-': 'Not resistant',
                'kA': 'No information available'
            },
            description:{
               'default': 'The material {{materials}} is {{resistanceValue}} for $t(resistanceTranslations.description.defaultMedia,{"count":{{mediumCount}}, "media":"{{mediadata}}"})',
               'default_plural': 'The materials {{materials}} are {{resistanceValue}} for $t(resistanceTranslations.description.defaultMedia,{"count":{{mediumCount}}, "media":"{{mediadata}}"})',
               'defaultMedia': 'the medium {{media}}',
               'defaultMedia_plural': 'the media {{media}}',
               'ka':'There is no information available for the combination of material {{materials}} and $t(resistanceTranslations.description.kaMedium, {"count": {{mediumCount}}, "media1":"{{mediadata}}" }).',
               'ka_plural':'There is no information available for the combination of material {{materials}} and $t(resistanceTranslations.description.kaMedium, {"count": {{mediumCount}}, "media1":"{{mediadata}}" }).',
               'kaMedium':'the medium {{media1}}',
               'kaMedium_plural':'the media {{media1}}'
            },
            resistanceResults:{
                '+': 'resistant',
                '(+)': 'resistant (Please note the limitations for the materials)', 
                'o': 'conditionally resistant',
                '(o)': 'conditionally resistant (Please note the limitations for the materials)',
                '-': 'not resistant',
                'kA': 'No information available'
            },
            maxKonzentration: 'maximum concentration ',
            maxTemperatur: 'maximum medium temperature '
        }, 
        disclaimer: {
            text: '<p>The following information serves primarily as a guide to aid the selection of suitable materials when using GEMÜ products. It cannot necessarily be applied to all operating conditions and applications. The specific selection of materials and the application, utilisation and processing of the products in question is the sole responsibility of the customer and/or end user.</p><p>Generally speaking, resistance depends on various factors, such as the temperature, concentration and degree of contamination of the medium, the type of mechanical load and the surface quality of the material. The different factors impact on the resistance of the materials in practice.</p><p>The content of this resistance information has been created by us to the best of our knowledge and belief. Nevertheless, we are unable to assume any liability as to whether the information provided is correct, complete or up to date. The information is in line with our level of knowledge at the time of publication. Errors excepted. We reserve the right to change, update or otherwise modify the data in the table at any time without prior notice.</p><p>Regardless of the legal grounds, no claims can be asserted pertaining to the use of this resistance information. This includes but is not limited to warranty claims, claims arising from erroneous advice or compensation claims.</p>',
            textCSV: 'The following information serves primarily as a guide to aid the selection of suitable materials when using GEMÜ products. It cannot necessarily be applied to all operating conditions and applications. The specific selection of materials and the application, utilisation and processing of the products in question is the sole responsibility of the customer and/or end user. Generally speaking, resistance depends on various factors, such as the temperature, concentration and degree of contamination of the medium, the type of mechanical load and the surface quality of the material. The different factors impact on the resistance of the materials in practice.            The content of this resistance information has been created by us to the best of our knowledge and belief. Nevertheless, we are unable to assume any liability as to whether the information provided is correct, complete or up to date. The information is in line with our level of knowledge at the time of publication. Errors excepted. We reserve the right to change, update or otherwise modify the data in the table at any time without prior notice. Regardless of the legal grounds, no claims can be asserted pertaining to the use of this resistance information. This includes but is not limited to warranty claims, claims arising from erroneous advice or compensation claims.',
            headline: 'Disclaimer',
            internalInformation:'Internal Information'
        },
        CSVOption:{
            Comma: 'CSV-Separator: "," - For english users',
            Semikolon: 'CSV-Seperator: ";" - For german users'
        },
        Excel:{
            goToTable: 'Accept and show table',
            CreationTime: 'File Created'
        },
        singleWords: {
            and: 'and'
        },
        searchTipps:{
            title: 'Tips for your search',
            tip1: 'You can search for the medium, material, chemical formula or CAS no.',
            // tip2: 'Combine different materials and media to get a more accurate result',
            tip2: 'Combine the medium and material to limit the results'
        },
        disclaimerFooter:{
            hastelloy:'Hastelloy is a (registered) trademark of Haynes International, Inc.,U.S.'
        }
    }
}

export default translations_en;
